import logger from '../utils/logger';
import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import "../style/InsurancePlan.css";

export default function InsurancePlanForm({
  initialData = {}
}) {
  const [form, setForm] = useState({
    planType: initialData.planType || "",
    planName: initialData.planName || "",
    address1: initialData.address1 || "",
    address2: initialData.address2 || "",
    city: initialData.city || "",
    state: initialData.state || "",
    zip: initialData.zip || "",
    phone: initialData.phone || "",
    fax: initialData.fax || "",
    payerId: initialData.payerId || "",
    ediServices: initialData.ediServices || "",
  });

  const [errors, setErrors] = useState({});

  const BASE_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const PLAN_TYPES = ["Commercial", "HMO", "Workers Comp"];
  const STATES = [
    "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"
  ];
  const EDI_SERVICES = ["Trizetto BCBS", "Trizetto Commercial", "Trizetto Institutional", "Paper (payer only accepts paper claims)"];

  function updateField(key, value) {
    setForm((f) => ({ ...f, [key]: value }));
    setErrors((e) => ({ ...e, [key]: undefined }));
  }

  // function validate() {
  //   const e = {};
  //   if (!form.planType) e.planType = "Select a plan type";
  //   if (!form.planName) e.planName = "Enter a plan name";
  //   if (!form.address1) e.address1 = "Enter address";
  //   if (!form.city) e.city = "Enter a city";
  //   if (!form.state) e.state = "Select a state";
  //   if (!form.zip) e.zip = "Enter a zip code";
  //   if (form.phone && !/^\d{7,15}$/.test(form.phone.replace(/[^\d]/g, ""))) {
  //     e.phone = "Enter a valid phone number";
  //   }
  //   setErrors(e);
  //   return Object.keys(e).length === 0;
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // logger.log('form: ', form)
      await addInsurance(form);
      alert("Insurance plan saved successfully!");
      navigate('/billing');
    } catch (err) {
      alert("Error saving insurance plan. Please try again.");
    }
  };

  const addInsurance = async (data) => {
    // logger.log('data: ', data)
    try {
      const response = await fetch(`${BASE_URL}/billing/addInsurancePlan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({data}), // user, type: currentUser.type,
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      // logger.log("Insurance plan added successfully:", result);
      return result;
    } catch (error) {
      logger.error("Failed to add insurance plan:", error);
      throw error;
    }
  };

  return (
  <>
    <div className="insurance-modal-overlay">
      <div className="insurance-modal">
        <div className="insurance-modal-header">
          <h2>Create New Insurance Plan</h2>
          <button className="close-btn" onClick={() => {navigate('/billing')}}>&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="insurance-modal-form">
          <div className="insurance-form-section">
            <h3>Plan Description</h3>
            <div className="insurance-form-grid">
              <div className="insurance-form-group">
                <label>Plan Type</label>
                <select
                  value={form.planType}
                  onChange={(e) => updateField('planType', e.target.value)}
                  className={errors.planType ? 'error' : ''}
                >
                  <option value="">Select Plan Type</option>
                  {PLAN_TYPES.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
                {errors.planType && <p className="error-text">{errors.planType}</p>}
              </div>

              <div className="insurance-form-group">
                <label>Plan Name</label>
                <input
                  type="text"
                  value={form.planName}
                  onChange={(e) => updateField('planName', e.target.value)}
                  placeholder="Enter Plan Name"
                  className={errors.planName ? 'error' : ''}
                />
                {errors.planName && <p className="error-text">{errors.planName}</p>}
              </div>
            </div>
          </div>

          <div className="insurance-form-section">
            <h3>Plan Details</h3>
            <div className="insurance-form-grid">
              <div className="insurance-form-group">
                <label>Address 1</label>
                <input
                  type="text"
                  value={form.address1}
                  onChange={(e) => updateField('address1', e.target.value)}
                  placeholder="Enter Address 1"
                  className={errors.address1 ? 'error' : ''}
                />
                {errors.address1 && <p className="error-text">{errors.address1}</p>}
              </div>

              <div className="insurance-form-group">
                <label>Address 2</label>
                <input
                  type="text"
                  value={form.address2}
                  onChange={(e) => updateField('address2', e.target.value)}
                  placeholder="Enter Address 2"
                />
              </div>

              <div className="insurance-form-group">
                <label>City</label>
                <input
                  type="text"
                  value={form.city}
                  onChange={(e) => updateField('city', e.target.value)}
                  placeholder="Enter City"
                  className={errors.city ? 'error' : ''}
                />
                {errors.city && <p className="error-text">{errors.city}</p>}
              </div>

              <div className="insurance-form-group">
                <label>State</label>
                <select
                  value={form.state}
                  onChange={(e) => updateField('state', e.target.value)}
                  className={errors.state ? 'error' : ''}
                >
                  <option value="">Select State</option>
                  {STATES.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
                {errors.state && <p className="error-text">{errors.state}</p>}
              </div>

              <div className="insurance-form-group">
                <label>Zip</label>
                <input
                  type="text"
                  value={form.zip}
                  onChange={(e) => updateField('zip', e.target.value)}
                  placeholder="Enter Zip code"
                  className={errors.zip ? 'error' : ''}
                />
                {errors.zip && <p className="error-text">{errors.zip}</p>}
              </div>

              <div className="insurance-form-group">
                <label>Phone</label>
                <input
                  type="tel"
                  value={form.phone}
                  onChange={(e) => updateField('phone', e.target.value)}
                  placeholder="Enter Phone Number"
                  className={errors.phone ? 'error' : ''}
                />
                {errors.phone && <p className="error-text">{errors.phone}</p>}
              </div>

              <div className="insurance-form-group">
                <label>Fax</label>
                <input
                  type="text"
                  value={form.fax}
                  onChange={(e) => updateField('fax', e.target.value)}
                  placeholder="Enter Fax Number"
                />
              </div>

              <div className="insurance-form-group">
                <label>Payer ID</label>
                <input
                  type="text"
                  value={form.payerId}
                  onChange={(e) => updateField('payerId', e.target.value)}
                  placeholder="Enter Payer ID"
                />
              </div>

              <div className="insurance-form-group">
                <label>EDI Services</label>
                <select
                  value={form.ediServices}
                  onChange={(e) => updateField('ediServices', e.target.value)}
                >
                  <option value="">Select EDI Services</option>
                  {EDI_SERVICES.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>

            </div>
          </div>

          <div className="insurance-form-actions">
            <button type="button" onClick={() => {navigate('/billing')}} className="insurance-btn insurance-btn-secondary">
              Cancel
            </button>
            <button type="submit" className="insurance-btn insurance-btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </>);
}
